import { getMessageTypesAndSenders } from 'api/ExperimentsAPI';
import { selectUserProjectId } from 'core/userContext';
import { MessageMedium } from 'modules/graphql';
import { addNegativeToast, errorIdentifier } from 'modules/toastContainer';
import { useDispatch, useSelector } from 'react-redux';
import { useExperimentsTranslations } from './useTranslations';

type ProjectEmailSendersType = {
  authorized: boolean;
  defaultReplyTo?: string;
  email: string;
  senderName?: string;
};

type SendersDataResponse = {
  data?: {
    emailSenders?: ProjectEmailSendersType[];
  };
};

const source = 'useEmailSenders';

export const useEmailSenders = () => {
  const { t } = useExperimentsTranslations();
  const dispatch = useDispatch();
  const errorToasterMessage = t('errorMessage.fetchEmailSenders');
  const projectId = useSelector(selectUserProjectId);
  return async (messageMedium: MessageMedium) => {
    try {
      const response: SendersDataResponse = await getMessageTypesAndSenders(
        projectId || 0,
        messageMedium,
      );
      const {
        data: { emailSenders: senders = [] } = {},
      } = response;
      return senders
        .filter(({ authorized }) => authorized)
        .map(({ email, senderName, defaultReplyTo }) => ({
          id: email,
          value: email,
          label: email,
          doubleLine: senderName,
          data: { defaultReplyTo },
        }));
    } catch (error) {
      dispatch(
        addNegativeToast(
          errorToasterMessage,
          errorIdentifier({
            source,
            error,
          }),
        ),
      );

      return [];
    }
  };
};
